export enum ValidationBarTheme {
  Error = 'error',
  Success = 'success',
  Information = 'information',
  Gray = 'gray'
}
